import { useEffect, useState } from 'react';
import { debounce } from 'lodash';

/**
 * Hook that returns current mouse coordinates.
 * @param ms Milliseconds delay between every mousemove event.
 */
export const useMousePosition = (ms = 1) => {
    const [mousePosition, setMousePosition] = useState<{ x: number; y: number } | null>(null);

    const onMouseMove = debounce((ev: MouseEvent) => {
        if (ev.clientX !== mousePosition?.x || ev.clientY !== mousePosition?.y) {
            setMousePosition({ x: ev.clientX, y: ev.clientY });
        }
    }, ms);

    useEffect(() => {
        window.addEventListener('mousemove', onMouseMove);

        return () => {
            window.removeEventListener('mousemove', onMouseMove);
        };
    }, []);

    return mousePosition;
};
